import {createGlobalStyle} from 'styled-components'

const GlobalStyle = createGlobalStyle`
  html {
    font-size: 14px;
  }

  body {
    font-family: 'Montserrat', sans-serif;
    color: #000;
  }

  a {
    &:hover {
      text-decoration: none;
    }
  }
  
  .object-cover-center {
    object-fit: cover;
    object-position: center center;
  }

  .img-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .img-cover-center {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
  }

  .img-contain-center {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center center;
  }
`

export default GlobalStyle
